module.exports = __webpack_public_path__ + "media/assets/images/layout/bg-sticky-f84974c946be6bb54b508a6d6f278885.png";